
<div class="wrapper">

  <mat-card *ngFor="let image of images">
      <mat-checkbox *ngIf="this.multiSelectionEnabled" #checkbox  [checked]="this.selectedImages.indexOf(image) > -1" (change)="this.toggleImageSelect(image)"></mat-checkbox>

    <mat-card-content>
      <section>
        <div class="image-wrapper"       
          (click)="singleSelection ? singleSelection.emit(image) : undefined"
          >
          <img [src]="image.base64 || image.thumbnailSource || image.source">
        </div>

        <hr>
        <div *ngIf="showInfo" class="image-info">
          <div *ngFor="let info of showInfo">
            <p *ngIf="info.link; else withoutLink">
              {{info.text}}: <a target="_blank" [href]="info.link(image)">{{info.value(image)}}</a>
            </p>
            <ng-template #withoutLink>
              <p>
                {{info.text}}: {{info.value(image)}}
              </p>
            </ng-template>
          </div>
        </div>



      </section>
    </mat-card-content>




    <!-- <mat-card-actions *ngIf="cardActions"> -->
    <mat-card-actions>
      <button
        *ngFor="let cardAction of cardActions"
        mat-button
        [matTooltip]="cardAction.tooltip"
        (click)="cardAction.subject.next(image)"
      >
        {{cardAction.text}}
      </button>
    </mat-card-actions>



  </mat-card>

</div>
